import Highcharts from 'highcharts'

// highcharts-vue 2.0.2 declares `beforeUnmount: () => this?.chart?.destroy()` in
// `node_modules/highcharts-vue/src/component.js:7`. The arrow function captures `this`
// from the module-level `generateVueComponent`, so `this` is `undefined` when the hook
// runs and `chart.destroy()` never executes. Delete this helper and the local plugin
// (src/lib/highchartsVue.ts) once upstream fixes that hook.
export function destroyChart(chart: Highcharts.Chart | undefined | null): void {
  if (chart && Highcharts.charts[chart.index] === chart) {
    chart.destroy()
  }
}
